import { createReducer } from 'utils/ReduxUtils';

import * as types from '../../../../actionTypes';

const initialState = false;

const displayModal = () => true;

const hideModal = () => false;

export default createReducer(initialState, {
  [types.DISPLAY_DUPLICATE_MODAL]: displayModal,
  [types.HIDE_DUPLICATE_MODAL]: hideModal,
});
